/* eslint-disable no-unused-vars */
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import Select from "react-select";
import * as yup from "yup";
import {
  accountNumberType,
  accountTypes,
  loanAccounType,
  loanType,
  productCategory,
  productTrigger,
} from "../../../../../utils/helpers/objectHelpers";
import { addNewProduct } from "../../../../../utils/services/customer-product.service";

function AddNewLoan({ dictionary, currency, chargeType, userId }) {
  const formRef = useRef();
  const languageStatus = !(
    typeof dictionary === "undefined" || dictionary === null
  );
  const accountType = accountTypes(languageStatus, dictionary);
  const menuPortalTarget = document.getElementById("root");
  const [loading, setLoading] = useState(false);
  const schema = yup
    .object({
      commonName: yup.string().required(),
      currencyCode: yup
        .object()
        .shape({
          iso3Code: yup.string(),
          label: yup.string(),
          value: yup.string(),
          currencyCode: yup.string(),
        })
        .required(),
      productCategory: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      productTrigger: yup
        .object()
        .shape({
          label: yup.string().required(),
          value: yup.string().required(),
        })
        .required(),
      loanType: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      accountNumberIssue: yup
        .object()
        .shape({
          label: yup.string().notRequired(),
          value: yup.string().notRequired(),
        })
        .notRequired(),
      accType: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      trenches: yup.number().notRequired(),
      loanAmount: yup.number().notRequired(),
      loanDuration: yup.number().notRequired(),
      loanDurationUnit: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .notRequired(),
      minAmount: yup.number().notRequired(),
      maxAmount: yup.number().notRequired(),
      message: yup.string().required(),
      accountProductType: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .notRequired(),
      accountNumber: yup
        .object()
        .shape({ label: yup.string(), value: yup.string() })
        .notRequired(),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const watchFields = watch(["accountNumberIssue"]);

  const onSubmit = async (data) => {
    setLoading(true);
    let product = {};
    if (chargeType === "LOAN") {
      const payload = {
        trigger: data?.productTrigger?.value,
        productName: data?.commonName,
        accountType: data?.accType?.value,
        currencyCode: data?.currencyCode?.currencyCode,
        apiProviderId: userId,
        accountProductType: data?.accountProductType?.value,
        loanAccountProductCategory: data?.productCategory?.value,
        defaultLoanAmount: data?.loanAmount,
        minimumLoanAmount: data?.minAmount,
        maximumLoanAmount: data?.maxAmount,
        trenches: data?.trenches,
        accountProductDescription: data?.message,
        loanType: data?.loanType?.value,
      };
      product = payload;
    } else if (chargeType === "DEPOSIT") {
      const payload = {
        trigger: data?.productTrigger?.value,
        productName: data?.commonName,
        currencyCode: data?.currencyCode?.currencyCode,
        accountProductDescription: data?.message,
        accountType: data?.accType?.value,
        accountNumberIssuingParty: data?.accountNumberIssue?.value,
      };
      product = payload;
    }
    try {
      const response = await addNewProduct(product);
      if (response.data.status === "SUCCESS") {
        toast.success(response?.data?.message);
        reset({
          commonName: "",
          currencyCode: {
            iso3Code: "",
            label: "",
            value: "",
            currencyCode: "",
          },
          productCategory: {
            label: "",
            value: "",
          },
          productTrigger: {
            label: "",
            value: "",
          },
          loanType: {
            label: "",
            value: "",
          },
          accountNumberIssue: {
            label: "",
            value: "",
          },
          accType: {
            label: "",
            value: "",
          },
          trenches: 0,
          loanAmount: 0,
          loanDuration: 0,
          loanDurationUnit: {
            label: "",
            value: "",
          },
          minAmount: 0,
          maxAmount: 0,
          message: "",
          accountProductType: {
            label: "",
            value: "",
          },
          accountNumber: { label: "", value: "" },
        });
        setLoading(false);
      } else {
        toast.error(response?.data?.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <div className="card-body">
      <form
        className="needs-validation"
        ref={formRef}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="form-row">
          {/* stays */}
          {chargeType === "LOAN" || chargeType === "DEPOSIT" ? (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary ? dictionary["WO_NAM_1793626496"] : "Name"}
                <span style={{ color: "red" }}> *</span>
              </label>
              <input
                type={"text"}
                className="form-control border px-3"
                name="commonName"
                {...register("commonName", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
            </div>
          ) : (
            ""
          )}
          {/* stays */}
          {chargeType === "LOAN" || chargeType === "DEPOSIT" ? (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["WO_SELECT_CURRENCY_COD_-1563592345"]
                  : "Select Currency Code"}
                <span style={{ color: "red" }}> *</span>
              </label>
              <Controller
                name="currencyCode"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={currency}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                    />
                  );
                }}
              />
            </div>
          ) : (
            ""
          )}

          {chargeType === "LOAN" && (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["WO_SELECT_PRODUCT_CATEG_-1105092435"]
                  : "Select Product Category"}
                <span style={{ color: "red" }}> *</span>
              </label>
              <Controller
                name="productCategory"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={productCategory()}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                    />
                  );
                }}
              />
            </div>
          )}

          {/* stays */}
          {chargeType === "LOAN" || chargeType === "DEPOSIT" ? (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["WO_SELECT_ACCOUNT_PRODU_-509324907"]
                  : "Select Account Product Trigger"}
                <span style={{ color: "red" }}> *</span>
              </label>
              <Controller
                name="productTrigger"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={productTrigger()}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                    />
                  );
                }}
              />
            </div>
          ) : (
            ""
          )}

          {chargeType === "DEPOSIT" && (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["WO_ACCOUNT_NUMBER_SOURC_852403649"]
                  : "Account Number Issuer Type"}
                {/* <span style={{ color: "red" }}> *</span> */}
              </label>
              <Controller
                name="accountNumberIssue"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={accountNumberType()}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                    />
                  );
                }}
              />
            </div>
          )}

          {chargeType === "DEPOSIT" &&
          watchFields[0]?.value === "EXTERNAL_PARTY" ? (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["WO_ACCOUNT_NUMBER_ISSUE_-1486977649"]
                  : "Account Number Issuer"}
                {/* <span style={{ color: "red" }}> *</span> */}
              </label>
              <Controller
                name="accountNumber"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={[
                        {
                          label:
                            "LHV Bank - Estonian Bank Financial Services Company - [EUR-EE3477007710]",
                          value: "EE3477007710",
                        },
                      ]}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                    />
                  );
                }}
              />
            </div>
          ) : (
            ""
          )}

          {chargeType === "LOAN" && (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["WO_SELECT_LOAN_TYP_1108210783"]
                  : "Select Loan Type"}
                <span style={{ color: "red" }}> *</span>
              </label>
              <Controller
                name="loanType"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={loanType()}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                    />
                  );
                }}
              />
            </div>
          )}

          {chargeType === "DEPOSIT" && (
            <div className="col-md-6 col-lg-6 mb-3">
              <>
                <label>
                  {dictionary
                    ? dictionary["WO_SELECT_ACCOUNT_TYP_-2127679859"]
                    : "Select Account Type"}
                  <span style={{ color: "red" }}> *</span>
                </label>
                <Controller
                  name="accType"
                  control={control}
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => {
                    return (
                      <Select
                        {...field}
                        options={accountType}
                        isClearable={false}
                        isSearchable={true}
                        maxMenuHeight={250}
                        menuPlacement="bottom"
                        menuPortalTarget={menuPortalTarget}
                      />
                    );
                  }}
                />
              </>
              <div className="form-row m-0">
                <label className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    defaultChecked={false}
                    // onChange={toggleCheckBox}
                  />
                  <span className="custom-control-label pointer fs-12">
                    <span>
                      {" "}
                      {dictionary
                        ? dictionary["para_activate_no_capital"]
                        : "Activate"}
                    </span>
                  </span>
                </label>
              </div>
            </div>
          )}

          {chargeType === "LOAN" && (
            <div className="col-md-6 col-lg-6 mb-3">
              <>
                <label>
                  {dictionary
                    ? dictionary["WO_SELECT_ACCOUNT_TYP_-2127679859"]
                    : "Select Account Type"}
                  <span style={{ color: "red" }}> *</span>
                </label>
                <Controller
                  name="accType"
                  control={control}
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => {
                    return (
                      <Select
                        {...field}
                        options={accountType}
                        isClearable={false}
                        isSearchable={true}
                        maxMenuHeight={250}
                        menuPlacement="bottom"
                        menuPortalTarget={menuPortalTarget}
                      />
                    );
                  }}
                />
              </>
            </div>
          )}

          {chargeType === "LOAN" ? (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary ? dictionary["WO_TRENCHES_904348747"] : "Trenches"}
                <span style={{ color: "red" }}> *</span>
              </label>
              <input
                type={"number"}
                className="form-control border px-3"
                name="trenches"
                {...register("trenches", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
            </div>
          ) : (
            ""
          )}

          {chargeType === "LOAN" && (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["WO_DEFAULT_LOAN_AMOUN_978133111"]
                  : "Default Loan Amount"}
                {/* <span style={{ color: "red" }}> *</span> */}
              </label>
              <input
                type={"number"}
                className="form-control border px-3"
                name="loanAmount"
                {...register("loanAmount", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
            </div>
          )}

          {chargeType === "LOAN" && (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["WO_LOAN_DURATIO_-854583182"]
                  : "Loan duration"}
                {/* <span style={{ color: "red" }}> *</span> */}
              </label>
              <input
                type={"number"}
                className="form-control border px-3"
                name="loanDuration"
                {...register("loanDuration", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
            </div>
          )}

          {chargeType === "LOAN" && (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["WO_LOAN_DURATION_UNI_879458186"]
                  : "Loan duration unit"}
                {/* <span style={{ color: "red" }}> *</span> */}
              </label>
              <Controller
                name="loanDurationUnit"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={[
                        { label: "Years", value: "YEARS" },
                        { label: "Months", value: "MONTHS" },
                        { label: "Days", value: "DAYS" },
                      ]}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                    />
                  );
                }}
              />
            </div>
          )}

          {chargeType === "LOAN" && (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["WO_MINIMUM_LOAN_AMOUN_-1256205337"]
                  : "Minimum Loan Amount"}
                {/* <span style={{ color: "red" }}> *</span> */}
              </label>
              <input
                type={"number"}
                className="form-control border px-3"
                name="minAmount"
                {...register("minAmount", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
            </div>
          )}

          {chargeType === "LOAN" && (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["WO_MAXIMUM_LOAN_AMOUN_197170208"]
                  : "Maximum Loan Amount"}
                {/* <span style={{ color: "red" }}> *</span> */}
              </label>
              <input
                type={"number"}
                className="form-control border px-3"
                name="maxAmount"
                {...register("maxAmount", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
              {/* <div className="form-row m-0">
                <label className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    defaultChecked={false}
                  />
                  <span className="custom-control-label pointer fs-12">
                    <span>
                      {" "}
                      {dictionary
                        ? dictionary["para_activate_no_capital"]
                        : "Activate"}
                    </span>
                  </span>
                </label>
              </div> */}
            </div>
          )}

          {chargeType === "LOAN" && (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {/* {dictionary
                  ? dictionary["WO_PRODUCT_DESCRIPTIO_-997141829"]
                  : "Product Type"} */}
                Product Type
                {/* <span style={{ color: "red" }}> *</span> */}
              </label>
              <Controller
                name="accountProductType"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={loanAccounType}
                      isClearable={false}
                      isSearchable={true}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                    />
                  );
                }}
              />
            </div>
          )}

          {chargeType === "LOAN" || chargeType === "DEPOSIT" ? (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {dictionary
                  ? dictionary["WO_PRODUCT_DESCRIPTIO_-997141829"]
                  : "Product Description"}
                {/* <span style={{ color: "red" }}> *</span> */}
              </label>
              <textarea
                className="form-control border px-3"
                name="message"
                {...register("message", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
            </div>
          ) : (
            ""
          )}
        </div>

        {chargeType === "LOAN" || chargeType === "DEPOSIT" ? (
          <div className="form-row">
            <div className="col-lg-6 col-md-6 mb-3" />
            <div className="col-lg-6 col-md-6 mb-3">
              <button
                className="btn btn-primary margin-label width-100 fw-bold"
                type="submit"
              >
                {"Save"}
                {loading && (
                  <>
                    &nbsp;
                    <i className="fa fa-spinner fa-spin" />
                  </>
                )}
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
      </form>
    </div>
  );
}

export default AddNewLoan;
